import React from 'react';

import VideoPlayer from './sections/VideoPlayer';
import Typography from './sections/Typography';
import TextInputs from './sections/TextInputs';
import SelectInputs from './sections/SelectInputs';
import Checkboxes from './sections/Checkboxes';
import Radios from './sections/Radios';
import Buttons from './sections/Buttons';
import Modal from './sections/Modal';
import Loading from '../common/components/Loading';

function StyleGuide() {
  return (
    <div className="styleguide container">
      <VideoPlayer />
      <Typography />
      <TextInputs />
      <SelectInputs />
      <Checkboxes />
      <Radios />
      <Buttons />
      <Modal />
      <div className="paper">
        <div className="styleguide__title">Loading</div>
        <div className="styleguide__row">
          <Loading />
        </div>
      </div>
    </div>
  );
}

export default StyleGuide;



// WEBPACK FOOTER //
// ./src/style-guide/StyleGuidePage.js